// src/components/SingleSelect.jsx

import React from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'

const SingleSelect = ({ label, value, onChange, items, labelId: labelIdProp }) => {
  const labelId = labelIdProp || `${label}-select-label`;
  return (
  <FormControl fullWidth>
    <InputLabel id={labelId}>{label}</InputLabel>
    <Select
      labelId={labelId}
      value={value}
      label={label}
      onChange={onChange}
    >
      {items.map(item => (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
  );
}

export default SingleSelect
